/* eslint-disable no-restricted-syntax */
/* eslint-disable import/no-cycle */
/* eslint-disable guard-for-in */
import { initialize } from 'launchdarkly-js-client-sdk'
import camelCase from 'lodash.camelcase'
import { setFlags as setFlagsAction } from '../scenes/Session/services/actions'

class Darkly {
  constructor() {
    this.id = null
    this.dispatch = null
    this.clientSideId = null
    this.flags = null
  }

  init(init) {
    this.id = init.clientSideId
    this.dispatch = init.dispatch
    this.clientSideId = init.clientSideId
    this.flags = init.flags

    const context = {
      kind: 'user',
      anonymous: true
    }
    window.ldClient = initialize(this.clientSideId, context)

    window.ldClient.on('ready', () => {
      const flagsSanitised = this.flags || window.ldClient.allFlags()
      this.setFlags(flagsSanitised, this.dispatch)
    })
    this.initFlags(this.flags, this.dispatch)
  }

  initFlags = (flags, dispatch) => {
    const flagValues = { isLDReady: false }
    for (const flag in flags) {
      const camelCasedKey = camelCase(flag)
      flagValues[camelCasedKey] = flags[flag]
    }
    dispatch(setFlagsAction(flagValues))
  }

  setFlags = (flags, dispatch) => {
    const flagValues = { isLDReady: true }
    for (const flag in flags) {
      const camelCasedKey = camelCase(flag)
      flagValues[camelCasedKey] = window.ldClient.variation(flag, flags[flag])
    }
    dispatch(setFlagsAction(flagValues))
  }

  subscribeToChanges = (flags, dispatch) => {
    for (const flag in flags) {
      const camelCasedKey = camelCase(flag)
      window.ldClient.on(`change:${flag}`, current => {
        const newFlagValue = {}
        newFlagValue[camelCasedKey] = current
        dispatch(setFlagsAction(newFlagValue))
      })
    }
  }

  identify = user => {
    window.ldClient.identify(user, null, (_, newFlags) => {
      this.setFlags(newFlags, this.dispatch)
    })
  }
}

export default new Darkly()
